import React from 'react';

export default React.createClass({
    
    propTypes: {
        index: React.PropTypes.number.isRequired,
        text: React.PropTypes.string.isRequired
    },
    
    render: function() {
        return (
            <div key={this.props.index} className="lui-subheader">{this.props.text}</div>
        );
    }
    
});


/** WEBPACK FOOTER **
 ** ./src/components/menu/SubheaderMenuItem.js
 **/